export default __webpack_public_path__ + "assets/fireworks-3007624f.mp4";